__turbopack_context__.v({
  "avatar": "index-module-scss-module__oTlGuG__avatar",
  "avatar__extraLarge": "index-module-scss-module__oTlGuG__avatar__extraLarge",
  "avatar__large": "index-module-scss-module__oTlGuG__avatar__large",
  "avatar__medium": "index-module-scss-module__oTlGuG__avatar__medium",
  "avatar__small": "index-module-scss-module__oTlGuG__avatar__small",
  "badgeBox": "index-module-scss-module__oTlGuG__badgeBox",
  "body": "index-module-scss-module__oTlGuG__body",
  "content": "index-module-scss-module__oTlGuG__content",
  "employee": "index-module-scss-module__oTlGuG__employee",
  "hirer": "index-module-scss-module__oTlGuG__hirer",
  "root": "index-module-scss-module__oTlGuG__root",
});
